import { createSlice } from '@reduxjs/toolkit'

export const sortOptions = createSlice({
  name: 'sortOptions',
  initialState: {},
  reducers: {
    setSortOptions: (state, action) => {
      return action?.payload
    },
  },
})

export const { setSortOptions } = sortOptions.actions
